import React from 'react';
import Icon from '../../../components/AppIcon';

const FinancialSummaryCard = ({ data }) => {
  return (
    <div className="card">
      <h3 className="text-xl font-heading font-semibold text-foreground mb-6">
        Financial Summary
      </h3>
      <div className="space-y-6">
        <div className="flex items-center justify-between pb-4 border-b border-border">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 rounded-lg bg-success/10 flex items-center justify-center">
              <Icon name="TrendingUp" size={20} color="var(--color-success)" />
            </div>
            <div>
              <p className="text-sm text-muted-foreground">Total Revenue</p>
              <p className="text-2xl font-heading font-semibold text-foreground data-text">
                ${data?.totalRevenue?.toLocaleString()}
              </p>
            </div>
          </div>
          <span className="text-sm font-medium text-success">+{data?.revenueGrowth}%</span>
        </div>

        <div className="space-y-3">
          <div className="flex items-center justify-between">
            <span className="text-sm text-muted-foreground">Membership Fees</span>
            <span className="text-sm font-medium text-foreground data-text">
              ${data?.membershipFees?.toLocaleString()}
            </span>
          </div>
          <div className="flex items-center justify-between">
            <span className="text-sm text-muted-foreground">Personal Training</span>
            <span className="text-sm font-medium text-foreground data-text">
              ${data?.personalTraining?.toLocaleString()}
            </span>
          </div>
          <div className="flex items-center justify-between">
            <span className="text-sm text-muted-foreground">Class Bookings</span>
            <span className="text-sm font-medium text-foreground data-text">
              ${data?.classBookings?.toLocaleString()}
            </span>
          </div>
          <div className="flex items-center justify-between">
            <span className="text-sm text-muted-foreground">Retail & Other</span>
            <span className="text-sm font-medium text-foreground data-text">
              ${data?.retail?.toLocaleString()}
            </span>
          </div>
        </div>

        <div className="pt-4 border-t border-border">
          <div className="flex items-center justify-between mb-2">
            <span className="text-sm font-medium text-foreground">Outstanding Balances</span>
            <span className="text-sm font-medium text-error data-text">
              ${data?.outstanding?.toLocaleString()}
            </span>
          </div>
          <div className="flex items-center gap-2 text-xs text-muted-foreground">
            <Icon name="AlertCircle" size={14} />
            <span>{data?.failedPayments} failed payments this month</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FinancialSummaryCard;